import { render, staticRenderFns } from "./WarehouseViewGlobal.vue?vue&type=template&id=8ce00a04"
import script from "./WarehouseViewGlobal.vue?vue&type=script&lang=js"
export * from "./WarehouseViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports